import actionPointsRepository from '../repository/actionPointsRepository';
import notificationService from '@/services/notificationService';
import { ActionPointStatus } from '../enums/actionPointStatus';

export default class ActionPoint implements IActionPointExtended {
    public id = '';
    public projectId = '';

    public title = '';
    public documentNumber = '';
    public content = '';

    public assignedSubcontractorId = '';
    public executorId = '';
    public reportedBy = '';
    public status: ActionPointStatus = ActionPointStatus.Open;
    public category = '';
    public internal = false;

    public priority = 0;
    public dueDate = '';

    public files: string[] = [];

    public saving = false;
    public loading = false;
    public dirty = false;

    public createdOn = '';
    public createdBy = '';
    public lastUpdatedOn = '';
    public lastUpdatedBy = '';

    public projectName = '';
    public projectNumber = '';
    public projectIsOnHold = false;

    // CTOR
    constructor(id?: string) {
        if (id) {
            this.init(id);
        }
    }

    // Update
    public async saveChanges() {
        try {
            this.saving = true;
            const result = await actionPointsRepository.update(this);
            Object.assign(this, result.data);
            setTimeout(() => {
                this.dirty = false;
            }, 150);
            notificationService.saved();
        } catch (err) {
            notificationService.showAxiosError(err);
        } finally {
            this.saving = false;
        }
    }

    // Load
    public async init(id: string) {
        try {
            this.loading = true;
            const result = (await actionPointsRepository.getSingle(id)).data;
            Object.assign(this, result);
        } catch (err) {
            notificationService.showErrorMessage('Er is iets verkeerd gelopen tijdens het laden van ');
        } finally {
            this.loading = false;
        }
    }
}
